import { SmartphoneIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { Button } from "@ui/button";

import { SadieSimulatorState } from "@/types";

// Where Sadie's texts are going right now: this page, or the tester's phone.
export const SadieSimulatorStatus = ({
  isStopping,
  onStop,
  simulator,
}: {
  isStopping: boolean;
  onStop: () => void;
  simulator: SadieSimulatorState | null;
}) => {
  /* Render */
  const render = () => {
    if (!simulator) {
      return (
        <Text className="text-xs font-normal text-slate-500">
          This tester is texting from their phone. Start over to bring them
          here. Texting &quot;Hey Ripley&quot; from their phone takes them back
          out.
        </Text>
      );
    }
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const modelName = simulator.model || "the production model";
    return (
      <Column className="gap-2">
        <Text className="text-xs font-normal text-slate-500">
          {`Sadie's texts come here, not to their phone. Running on ${modelName}.`}
        </Text>
        <Button
          disabled={isStopping}
          onClick={onStop}
          size="sm"
          variant="outline"
        >
          <SmartphoneIcon className="h-4 w-4" />
          Send texts to their phone again
        </Button>
      </Column>
    );
  };

  return render();
};
